"use strict";
/*
 * Created on 16.10.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ManualPromoWeekSplit_1 = require("../model/ManualPromoWeekSplit");

var ManualPromoWeekSplitConverter_1 = require("./ManualPromoWeekSplitConverter");
/**
 * @author Radek Beran
 */


var ManualPromoWeekSplitConverterImpl =
/*#__PURE__*/
function (_ManualPromoWeekSplit) {
  _inherits(ManualPromoWeekSplitConverterImpl, _ManualPromoWeekSplit);

  function ManualPromoWeekSplitConverterImpl() {
    _classCallCheck(this, ManualPromoWeekSplitConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ManualPromoWeekSplitConverterImpl).apply(this, arguments));
  }

  _createClass(ManualPromoWeekSplitConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ManualPromoWeekSplit_1.ManualPromoWeekSplit(ManualPromoWeekSplit_1.ManualPromoWeekSplit.schema.promoWeek.valueOfField(source), ManualPromoWeekSplit_1.ManualPromoWeekSplit.schema.splitPercent.valueOf(conversions.toBigNumber(source.splitPercent)));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        promoWeek: source.promoWeek,
        splitPercent: conversions.fromBigNumber(source.splitPercent)
      });
      return result;
    }
  }]);

  return ManualPromoWeekSplitConverterImpl;
}(ManualPromoWeekSplitConverter_1.ManualPromoWeekSplitConverter);

exports.ManualPromoWeekSplitConverterImpl = ManualPromoWeekSplitConverterImpl;